<div [ngClass]="{ 'col-package-sidebar': isSidebar, 'col-package-external': isExternal }">
  <div *ngIf="formGroup" class="col-form-row">
    <div class="col-package-quantity">
      <div class="col-package-quantity-input-package">
        <app-control-wrapper [control]="formGroup.get(['type'])" [errors]="typeErrors" [isShowHelper]="false">
          <label [for]="'package-type-' + index" control-label>{{ "LABELS.PACKAGE_TYPE" | translate }}</label>
          <ng-select
            class="custom"
            [formControl]="formGroup.get('type')"
            control-wrapper
            bindLabel="label"
            bindValue="value"
            [items]="typeSelect"
            [id]="'package-type-' + index"
            [clearable]="false"
            [searchable]="false"
          ></ng-select>
        </app-control-wrapper>
      </div>

      <div class="col-package-quantity-input-quantity">
        <app-control-wrapper [control]="formGroup.get(['quantity'])" [errors]="errors" [isShowHelper]="false">
          <label [for]="'package-quantity-' + index" control-label>{{ "NUM_OF_UNITS" | translate }}</label>
          <div control-wrapper class="col-package-quantity-input-quantity-wrapper">
            <div
              class="col-package-quantity-input-quantity-change col-package-quantity-input-quantity-change-less"
              (click)="decreaseQuantity()"
            >
              <!--we use svg this way to color it on hover & focus (currentColor)-->
              <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H10V2H0V0Z" fill="currentColor" />
              </svg>
            </div>
            <input
              type="text"
              [formControl]="formGroup.get(['quantity'])"
              class="form-control"
              [id]="'package-quantity-' + index"
              [name]="'package-quantity-' + index"
              [mask]="numberInputData.mask"
              [attr.pattern]="numberInputData.pattern"
              [appMaskErrorTooltip]="numberInputData.maskErrorTooltip"
            />

            <div
              class="col-package-quantity-input-quantity-change col-package-quantity-input-quantity-change-more"
              (click)="increaseQuantity()"
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 4H10V6H0V4Z" fill="currentColor" />
                <path d="M4 10V0H6V10H4Z" fill="currentColor" />
              </svg>
            </div>
          </div>
        </app-control-wrapper>
      </div>
    </div>

    <div class="col-box-dimensions" *ngIf="isShowBoxInput">
      <div class="col-box-dimensions-input-lwh">
        <span class="col-box-dimensions-input-lwh-length-label">{{ "UNIT_DIMENSIONS_L_W_H" | translate }}</span>
        <div class="d-flex form-control-group">
          <div class="col-box-dimensions-input-lwh-length">
            <app-control-wrapper [control]="formGroup.get(['dimensions', 'length'])" [errors]="errors" [isShowHelper]="false">
              <input
                type="text"
                inputmode="numeric"
                class="form-control length"
                placeholder="L"
                control-wrapper
                [formControl]="formGroup.get(['dimensions', 'length'])"
                [id]="'package-length-' + index"
                [name]="'package-length-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-lwh-width">
            <app-control-wrapper [control]="formGroup.get(['dimensions', 'width'])" [errors]="errors" [isShowHelper]="false">
              <input
                type="text"
                inputmode="numeric"
                class="form-control width"
                placeholder="W"
                control-wrapper
                [formControl]="formGroup.get(['dimensions', 'width'])"
                [id]="'package-width-' + index"
                [name]="'package-width-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-lwh-height">
            <app-control-wrapper [control]="formGroup.get(['dimensions', 'height'])" [errors]="errors" [isShowHelper]="false">
              <input
                type="text"
                inputmode="numeric"
                class="form-control height"
                placeholder="H"
                control-wrapper
                [formControl]="formGroup.get(['dimensions', 'height'])"
                [id]="'package-height-' + index"
                [name]="'package-height-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-lwh-unit">
            <app-control-wrapper [control]="formGroup.get('lengthUnit')" [errors]="errors" [isShowHelper]="false">
              <ng-select
                class="custom blue unit"
                control-wrapper
                [formControl]="formGroup.get('lengthUnit')"
                [id]="'package-lengthUnit-' + index"
                [items]="lengthUnits"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item | lengthUnit | translate }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item | lengthUnit | translate }}
                </ng-template>
              </ng-select>
            </app-control-wrapper>
          </div>
        </div>
      </div>

      <div class="col-box-dimensions-input-weight">
        <div class="d-flex form-control-group">
          <div class="col-box-dimensions-input-weight-input">
            <app-control-wrapper [control]="formGroup.get(['weight'])" [errors]="errors" [isShowHelper]="false">
              <label [for]="'package-weight-' + index" control-label>{{ "LABELS.WEIGHT" | translate }}</label>
              <input
                type="text"
                inputmode="numeric"
                class="form-control weight"
                control-wrapper
                [formControl]="formGroup.get(['weight'])"
                [id]="'package-weight-' + index"
                [name]="'package-weight-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-weight-unit">
            <app-control-wrapper [control]="formGroup.get('weightUnit')" [errors]="errors" [isShowHelper]="false">
              <label [for]="'package-weightUnit-' + index" control-label></label>
              <ng-select
                class="custom blue unit"
                [formControl]="formGroup.get('weightUnit')"
                control-wrapper
                [id]="'package-weightUnit-' + index"
                [items]="weightUnits"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item | weightUnit | translate }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item | weightUnit | translate }}
                </ng-template>
              </ng-select>
            </app-control-wrapper>
          </div>
        </div>
      </div>
    </div>

    <div class="col-pallet-dimensions" *ngIf="isShowPalletInput">
      <div class="col-pallet-dimensions-input-pallet-type">
        <app-control-wrapper [control]="formGroup.get('palletStandard')" [errors]="typeErrors" [isShowHelper]="false">
          <label [for]="'package-palletStandard-' + index" control-label>{{ "PALLET_TYPE" | translate }}</label>
          <ng-select
            class="custom"
            control-wrapper
            bindLabel="label"
            bindValue="value"
            [formControl]="formGroup.get('palletStandard')"
            [items]="palletStandardSelect"
            [id]="'package-palletStandard-' + index"
            [clearable]="false"
            [searchable]="false"
            [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
          ></ng-select>
        </app-control-wrapper>
      </div>

      <div class="col-box-dimensions-input-lwh" *ngIf="!isShowPalletStandardInput">
        <span class="col-box-dimensions-input-lwh-length-label">{{ "UNIT_DIMENSIONS_L_W_H" | translate }}</span>
        <div class="d-flex form-control-group">
          <div class="col-box-dimensions-input-lwh-length">
            <app-control-wrapper [control]="formGroup.get(['dimensions', 'length'])" [errors]="errors" [isShowHelper]="false">
              <input
                type="text"
                inputmode="numeric"
                class="form-control length"
                placeholder="L"
                control-wrapper
                [formControl]="formGroup.get(['dimensions', 'length'])"
                [id]="'package-length-' + index"
                [name]="'package-length-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-lwh-width">
            <app-control-wrapper [control]="formGroup.get(['dimensions', 'width'])" [errors]="errors" [isShowHelper]="false">
              <input
                type="text"
                inputmode="numeric"
                class="form-control width"
                placeholder="W"
                control-wrapper
                [formControl]="formGroup.get(['dimensions', 'width'])"
                [id]="'package-width-' + index"
                [name]="'package-width-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-lwh-height">
            <app-control-wrapper [control]="formGroup.get(['dimensions', 'height'])" [errors]="errors" [isShowHelper]="false">
              <input
                type="text"
                inputmode="numeric"
                class="form-control height"
                placeholder="H"
                control-wrapper
                [formControl]="formGroup.get(['dimensions', 'height'])"
                [id]="'package-height-' + index"
                [name]="'package-height-' + index"
                [mask]="decimalInputData.mask"
                [attr.pattern]="decimalInputData.pattern"
                [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                [dropSpecialCharacters]="false"
              />
            </app-control-wrapper>
          </div>

          <div class="col-box-dimensions-input-lwh-unit">
            <app-control-wrapper [control]="formGroup.get('lengthUnit')" [errors]="errors" [isShowHelper]="false">
              <ng-select
                class="custom blue unit"
                control-wrapper
                [formControl]="formGroup.get('lengthUnit')"
                [id]="'package-lengthUnit-' + index"
                [items]="lengthUnits"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item | lengthUnit | translate }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item | lengthUnit | translate }}
                </ng-template>
              </ng-select>
            </app-control-wrapper>
          </div>
        </div>
      </div>

      <div class="col-pallet-dimensions-input-height-weight">
        <div class="col-pallet-dimensions-input-standard-height" *ngIf="isShowPalletStandardInput">
          <div class="d-flex form-control-group">
            <div class="col-pallet-dimensions-input-standard-height-input">
              <app-control-wrapper [control]="formGroup.get(['dimensions', 'height'])" [errors]="errors" [isShowHelper]="false">
                <label [for]="'package-height-pallet-' + index" control-label>{{ "LABELS.HEIGHT" | translate }}</label>
                <input
                  type="text"
                  inputmode="numeric"
                  class="form-control height"
                  control-wrapper
                  [formControl]="formGroup.get(['dimensions', 'height'])"
                  [id]="'package-height-pallet-' + index"
                  [name]="'package-height-pallet-' + index"
                  [mask]="decimalInputData.mask"
                  [attr.pattern]="decimalInputData.pattern"
                  [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                  [dropSpecialCharacters]="false"
                />
              </app-control-wrapper>
            </div>

            <div class="col-pallet-dimensions-input-standard-height-unit">
              <app-control-wrapper [control]="formGroup.get('lengthUnit')" [errors]="errors" [isShowHelper]="false">
                <label [for]="'package-lengthUnit-pallet-' + index" control-label></label>
                <ng-select
                  class="custom blue unit"
                  [formControl]="formGroup.get('lengthUnit')"
                  control-wrapper
                  [id]="'package-lengthUnit-pallet-' + index"
                  [items]="lengthUnits"
                  [clearable]="false"
                  [searchable]="false"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item | lengthUnit | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item | lengthUnit | translate }}
                  </ng-template>
                </ng-select>
              </app-control-wrapper>
            </div>
          </div>
        </div>

        <div class="col-pallet-dimensions-input-weight" [ngClass]="{ 'is-with-standard': isShowPalletStandardInput }">
          <div class="d-flex form-control-group">
            <div class="col-pallet-dimensions-input-weight-input">
              <app-control-wrapper [control]="formGroup.get(['weight'])" [errors]="errors" [isShowHelper]="false">
                <label [for]="'package-weight-pallet-' + index" control-label>{{ "LABELS.WEIGHT" | translate }}</label>
                <input
                  type="text"
                  inputmode="numeric"
                  class="form-control weight"
                  control-wrapper
                  [formControl]="formGroup.get(['weight'])"
                  [id]="'package-weight-pallet-' + index"
                  [name]="'package-weight-pallet-' + index"
                  [mask]="decimalInputData.mask"
                  [attr.pattern]="decimalInputData.pattern"
                  [appMaskErrorTooltip]="decimalInputData.maskErrorTooltip"
                  [dropSpecialCharacters]="false"
                />
              </app-control-wrapper>
            </div>

            <div class="col-pallet-dimensions-input-weight-unit">
              <app-control-wrapper [control]="formGroup.get('weightUnit')" [errors]="errors" [isShowHelper]="false">
                <label [for]="'package-weightUnit-pallet-' + index" control-label></label>
                <ng-select
                  class="custom blue unit"
                  [formControl]="formGroup.get('weightUnit')"
                  control-wrapper
                  [id]="'package-weightUnit-pallet-' + index"
                  [items]="weightUnits"
                  [clearable]="false"
                  [searchable]="false"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item | weightUnit | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item | weightUnit | translate }}
                  </ng-template>
                </ng-select>
              </app-control-wrapper>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-stackable">
      <app-control-wrapper [control]="formGroup.get(['stackable'])" [errors]="errors" [isShowHelper]="false">
        <label
          [for]="'package-stackable-' + index"
          control-label
          class="d-none"
          [ngClass]="{ 'd-md-none': isSidebar, 'd-md-inline': !isSidebar }"
        >
          {{ "LABELS.STACKABLE" | translate }}
        </label>
        <div control-wrapper class="custom-control custom-checkbox mt-3" [ngClass]="{ 'mt-4': isExternal }">
          <input
            type="checkbox"
            [formControl]="formGroup.get('stackable')"
            class="custom-control-input"
            [id]="'package-stackable-' + index"
          />
          <label class="custom-control-label" [for]="'package-stackable-' + index">
            <span [ngClass]="{ 'd-md-none': !isSidebar }">{{ "LABELS.STACKABLE" | translate }}</span>
          </label>
        </div>
      </app-control-wrapper>
    </div>

    <div class="col-buttons text-right">
      <button class="btn btn-clean-form" *ngIf="!isShowClear" [disabled]="isAdminView ? false : isLastest" (click)="onRemoveQuote()">
        <i class="fa fa-trash"></i>
      </button>

      <button class="btn btn-clean-form" *ngIf="isShowClear" (click)="onClear()">
        <i class="fa fa-trash"></i>
        <span>{{ "FORM_LABEL.CLEAR_FORM" | translate }}</span>
      </button>
    </div>
  </div>
</div>
